import React from 'react';
import styled from 'styled-components';
import Stat from './common/stat';
import { getTotalFigures } from './transform';
import useFollowersStore from './state-hook';

// width and height set in parent styles, do not set it here
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font: ${props => props.theme.fontWeightHeavy} 19px/120% ${props => props.theme.fontFamilyBody};
  color: #627484;
`;

const SubTitle = styled.div`
  font: ${props => props.theme.fontWeightRegular} 16px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  margin-top: 8px;
  max-width: 340px;
`;

const Stats = styled.div`
  margin-top: 40px;
  display: flex;
  height: 48px;
`;

const TotalStat = styled(Stats)`
  height: 57px;
`;

export default function Figures() {
  const followers = useFollowersStore(state => state.followers);
  const [stats, setStats] = React.useState({ total: NaN, gained: NaN, lost: NaN });

  React.useEffect(() => {
    setStats(getTotalFigures(followers));
  }, [followers]);

  return (
    <Container>
      <Title>How is my follower growth tracking over time?</Title>
      <SubTitle>You can track how your followers have grown over a selected date range.</SubTitle>
      <TotalStat>
        <Stat type="followers" number={stats.total} primary />
      </TotalStat>
      <Stats>
        <Stat type="gained" number={stats.gained} />
        <Stat type="lost" number={stats.lost} />
      </Stats>
    </Container>
  );
}
